import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "survey_question" }
const _hoisted_2 = {
  class: "survey_prompt",
  for: "type"
}
const _hoisted_3 = { class: "survey_responses" }
const _hoisted_4 = ["value"]
const _hoisted_5 = ["label"]
const _hoisted_6 = ["value"]

import { computed, WritableComputedRef } from "vue";

interface OptionGroup {
  label: string;
  options: T[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TandemSelect',
  props: {
    label: {},
    modelValue: {},
    options: {},
    groups: {},
    getKey: { type: Function },
    getLabel: { type: Function }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;

/* eslint-disable no-undef, no-unused-vars */




const value: WritableComputedRef<T | undefined> = computed({
  get(): T | undefined {
    return props.modelValue;
  },
  set(value: T | undefined) {
    emit("update:modelValue", value);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.label), 1),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("select", {
        name: "content",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props?.options, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            key: _ctx.getKey(option),
            value: option
          }, _toDisplayString(_ctx.getLabel(option)), 9, _hoisted_4))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props?.groups, (group) => {
          return (_openBlock(), _createElementBlock("optgroup", {
            key: group.label,
            label: group.label
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (option) => {
              return (_openBlock(), _createElementBlock("option", {
                key: _ctx.getKey(option),
                value: option
              }, _toDisplayString(_ctx.getLabel(option)), 9, _hoisted_6))
            }), 128))
          ], 8, _hoisted_5))
        }), 128))
      ], 512), [
        [_vModelSelect, value.value]
      ])
    ])
  ]))
}
}

})